import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function VATLabel() {
    return (
        <span className="prices__vat">
            <FormattedMessage
                id="listing.price.vat"
                defaultMessage=" inc VAT"
                description="VAT label of price"
            />
        </span>
    );
}
